module.exports = __webpack_public_path__ + "img/ai.4b5b76b4.png";